<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">İl</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" class="form-control" placeholder="İl" v-model="value.Name">
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Ülke</label>
            <v-validator :errors="errors" parameter="CountryId" :watch="country">
                <v-select-list v-model="country" placeholder="Ülke" label="Name" :options="countries"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Bölge</label>
            <v-validator :errors="errors" parameter="RegionId" :watch="region">
                <v-select-list v-model="region" placeholder="Bölge" label="Name" :options="regions"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">X Koordinatı</label>
            <v-validator :errors="errors" parameter="X_Coordinate" :watch="value.X_Coordinate">
                <input type="text" class="form-control" placeholder="X Koordinatı" v-model="value.X_Coordinate">
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Y Koordinatı</label>
            <v-validator :errors="errors" parameter="Y_Coordinate" :watch="value.Y_Coordinate">
                <input type="text" class="form-control" placeholder="Y Koordinatı" v-model="value.Y_Coordinate">
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Endeks</label>
            <v-validator :errors="errors" parameter="Y_Coordinate" :watch="value.Index">
                <input type="number" class="form-control" placeholder="Endeks" v-model="value.Index">
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Endeks Kategorisi</label>
            <v-validator :errors="errors" parameter="ProvinceIndexCategoryId" :watch="category">
                <v-select-list v-model="category" placeholder="Endeks Kategorisi" label="Name" :options="categories"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'

export default{
    props:{
        value:Object,
        errors:Object
    },
    mounted(){
        this.getCountries()
        this.getRegions()
        this.getIndexCategories()
    },
    data(){
        return {
            countries:[],
            regions:[],
            categories:[]
        }
    },
    methods:{
        getCountries(){
            SystemDataApi.Country().then(res=>{
                this.countries = res.data.Data
            })
        },
        getRegions(){
            SystemDataApi.Region().then(res=>{
                this.regions = res.data.Data
            })
        },
        getIndexCategories(){
            SystemDataApi.ProvinceIndexCategory.List().then(res => {
                this.categories = res.data.Data || []
            })
        }
    },
    computed:{
        country:{
            get:function(){
                return this.countries.find(b=>b.Id==this.value.CountryId)
            },
            set:function(value){
                this.value.CountryId = value?.Id || null
            }
        },
        region:{
            get:function(){
                return this.regions.find(b=>b.Id==this.value.RegionId)
            },
            set:function(value){
                this.value.RegionId = value?.Id || null
            }
        },
        category:{
            get:function(){
                return this.categories.find(b=>b.Id==this.value.ProvinceIndexCategoryId)
            },
            set:function(value){
                this.value.ProvinceIndexCategoryId = value?.Id || null
            }
        },
    },
}
</script>